import * as Yup from 'yup';

const initialValues = () => ({
  onboarding_waitlist: '',
});

const schema = Yup.object().shape({
  email: Yup.string().email('Please enter a valid email address.').required(),
});

export const validation = {
  initialValues,
  schema,
};
